export default __webpack_public_path__ + "static/media/5Star.70b9b81c.jpg";